var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "伙伴名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入伙伴名称查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.partnerName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "partnerName",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.partnerName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "user-add" },
                          on: { click: _vm.openInviteModal },
                        },
                        [_vm._v("邀请伙伴")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "partnerRole",
                        fn: function (text, record) {
                          return [
                            _vm.partnerRoleOf(record) === "供应商"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("供应商"),
                                ])
                              : _vm.partnerRoleOf(record) === "客户"
                              ? _c("a-tag", { attrs: { color: "blue" } }, [
                                  _vm._v("客户"),
                                ])
                              : _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("未关联"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "myArchive",
                        fn: function (text) {
                          return [
                            text
                              ? _c("span", [_vm._v(_vm._s(text))])
                              : _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("未关联"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _vm.btnEnableList.indexOf(1) > -1
                                ? [
                                    !record.supplierId
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openLinkModal(record)
                                              },
                                            },
                                          },
                                          [_vm._v("关联档案")]
                                        )
                                      : _vm._e(),
                                    !record.supplierId
                                      ? _c("a-divider", {
                                          attrs: { type: "vertical" },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "a-popconfirm",
                                      {
                                        attrs: {
                                          title:
                                            "解绑后双方将无法进行订单流转，确定解绑吗?",
                                        },
                                        on: {
                                          confirm: () =>
                                            _vm.handleUnbind(record),
                                        },
                                      },
                                      [_c("a", [_vm._v("解绑")])]
                                    ),
                                  ]
                                : _c("span", [_vm._v("-")]),
                            ],
                            2
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "邀请伙伴",
                    visible: _vm.inviteVisible,
                    footer: null,
                    maskClosable: false,
                    width: "560px",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.inviteVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form",
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "邀请角色",
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.inviteRole,
                                callback: function ($$v) {
                                  _vm.inviteRole = $$v
                                },
                                expression: "inviteRole",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: "supplier" } }, [
                                _vm._v("邀请供应商（对方作为我的供应商）"),
                              ]),
                              _c("a-radio", { attrs: { value: "customer" } }, [
                                _vm._v("邀请客户（对方作为我的客户）"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "关联本方档案",
                            required: "",
                          },
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              placeholder: "请选择本方档案（仅列出未绑定的）",
                              options: _vm.inviteArchiveOptions,
                              allowClear: "",
                            },
                            on: { change: _vm.buildInviteLinks },
                            model: {
                              value: _vm.inviteArchiveId,
                              callback: function ($$v) {
                                _vm.inviteArchiveId = $$v
                              },
                              expression: "inviteArchiveId",
                            },
                          }),
                          !_vm.inviteArchiveOptions.length
                            ? _c("div", { staticClass: "invite-archive-tip" }, [
                                _vm._v(
                                  "暂无可关联档案，可先在基础资料-供应商/客户管理中新增"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-divider", [_vm._v("发送给对方")]),
                  _c(
                    "div",
                    { staticClass: "invite-block" },
                    [
                      _c("div", { staticClass: "invite-label" }, [
                        _vm._v("H5 注册/登录链接"),
                      ]),
                      _c("div", { staticClass: "invite-link" }, [
                        _vm._v(_vm._s(_vm.inviteH5Url)),
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.copyInviteText(_vm.inviteH5Url)
                            },
                          },
                        },
                        [_vm._v("复制链接")]
                      ),
                    ],
                    1
                  ),
                  _vm.inviteRole === "customer"
                    ? _c(
                        "div",
                        { staticClass: "invite-block" },
                        [
                          _c("div", { staticClass: "invite-label" }, [
                            _vm._v("小程序页面路径（发给您的小程序客户）"),
                          ]),
                          _c("div", { staticClass: "invite-link" }, [
                            _vm._v(_vm._s(_vm.inviteMiniPath)),
                          ]),
                          _c(
                            "a-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyInviteText(_vm.inviteMiniPath)
                                },
                              },
                            },
                            [_vm._v("复制路径")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "invite-tip" }, [
                    _vm._v(
                      "对方通过链接注册或登录后，双方建立伙伴绑定，并自动关联到所选档案。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "关联本方档案",
                    visible: _vm.linkVisible,
                    maskClosable: false,
                    width: "480px",
                    confirmLoading: _vm.linkSubmitting,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.linkVisible = false
                    },
                    ok: _vm.handleLinkOk,
                  },
                },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "本方档案",
                        required: "",
                      },
                    },
                    [
                      _c("a-select", {
                        attrs: {
                          placeholder: "请选择本方档案（仅列出未绑定的）",
                          options: _vm.linkArchiveOptions,
                          allowClear: "",
                        },
                        model: {
                          value: _vm.linkArchiveId,
                          callback: function ($$v) {
                            _vm.linkArchiveId = $$v
                          },
                          expression: "linkArchiveId",
                        },
                      }),
                      !_vm.linkArchiveOptions.length
                        ? _c("div", { staticClass: "invite-archive-tip" }, [
                            _vm._v(
                              "暂无可关联档案，可先在基础资料-供应商/客户管理中新增"
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "invite-tip" }, [
                    _vm._v(
                      "关联后，对方发来的采购订单将自动流转到您本地的对应单据往来中。"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }